<template>
  <div>
    <label class="dialog-time-picker-label">Time</label>
    <vue-timepicker class="dialog-time-picker-input" v-model="time" auto-scroll :disabled="readonly" @change="timePicked" manual-input hide-disabled-items format="hh:mm A" :hour-range="[[1, 24]]" :minute-range="[0, 15, 30, 45]">
      <template v-slot:icon>
        <v-icon color="accent">bhi-clock</v-icon>
      </template>
    </vue-timepicker>
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
export default {
  name: 'DialogTimePicker',
  components: {VueTimepicker},
  props: {
    name: {
      type: String,
      default: 'date'
    },
    initialTime: {
      type: String,
      default: '06:00 AM',
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      time: '',
      timeFormatted: '',
      menu: false,
      allowedMinutes: [0, 15, 30, 45],
      timePickedTimeout: false
    }
  },

  mounted() {
    this.time = this.formatTime(this.initialTime)
  },
  watch: {
    initialTime(val) {
      this.time = this.formatTime(this.initialTime)
    }
  },
  computed: {
    formattedTime() {
      return this.formatTime2(this.time)
    }
  },

  methods: {
    formatTime (time) {
      return this.$moment(time, "HH:mm").format("hh:mm A")
    },
    formatTime2 (time) {
      if (this.$moment(time, "HH:mm").isValid())
        return this.$moment(time, "HH:mm").format("HH:mm")
      else return time
    },
    timePicked (time) {
      this.roundTime(time)
    },
    roundTime(time) {
      clearTimeout(this.timePickedTimeout)
      this.timePickedTimeout = setTimeout(()=>{
        const tmpTime = new Date(Math.round(this.$moment(time.data.HH+':'+time.data.mm, "HH:mm") / 9e5) * 9e5)
        this.time = this.$moment(tmpTime).format("HH:mm")
        this.timeFormatted = this.$moment(this.time, "hh:mm A").format("hh:mm A")
        this.$emit('input', { name: this.name, value: this.time })
      },1000)
    }
  }
}
</script>
<style lang="scss">
.dialog-time-picker {
  &-label {
    color: $bh-gray--2;
    display: block;
  }

  &-input {
    background: $bh-white;
    border-radius: 8px;
    width: 100%;
    ul li:not([disabled]).active, ul li:not([disabled]).active:focus, ul li:not([disabled]).active:hover, .dropdown ul li:not([disabled]).active, .dropdown ul li:not([disabled]).active:focus, .dropdown ul li:not([disabled]).active:hover {
        background: $bh-blue !important;
      }
    input {
      padding: $gutter !important;
      padding-left:40px !important;
      width: calc(100% - 30px) !important;
      line-height: 16px;
      height: auto !important;
      border:0 !important;
      outline: 0 !important;
    }
    .controls {
      margin-right: 5px;
    }
    .custom-icon {
      margin-left: 8px;
    }
    &.v-input--is-readonly {
      .v-input__control {
        .v-input__slot {
          background-color: $bh-white !important;
        }
      }
    } 
    &.readonly {
      &.v-input--is-readonly {
        .v-input__control {
          .v-input__slot {
            background-color: transparent !important;
          }
        }
      } 
      .v-icon {
        color: $bh-gray--2 !important;
      }
    }
  }
  &-modal {
    .v-time-picker-clock__item {
      cursor: pointer;
    }
  }
}
</style>